import React, { act } from "react"
import { createRoot } from "react-dom/client"
import { Formik, Form } from "formik"

// eslint-disable-next-line import/first
import View from "./Attachment"

const testGlobal = globalThis as any
testGlobal.IS_REACT_ACT_ENVIRONMENT = true

const renderEditView = (component) => {
  const container = document.createElement("div")
  document.body.appendChild(container)

  act(() => {
    createRoot(container).render(
      <Formik initialValues={component} onSubmit={() => {}}>
        <Form>
          <View component={component} editing />
        </Form>
      </Formik>
    )
  })

  return container
}

const downloadLink = (container: HTMLElement) =>
  Array.from(container.querySelectorAll("a")).find((a) => a.textContent === "Download") ?? null

describe("Attachment edit view", () => {
  afterEach(() => {
    document.body.innerHTML = ""
  })

  it("shows a download link for the persisted file so it survives a collapse/expand remount", () => {
    const container = renderEditView({ name: "Waiver", description: "", fileSrc: "abc-123" })

    const link = downloadLink(container)
    expect(link).not.toBeNull()
    expect(link?.getAttribute("href")).toContain("abc-123")
  })

  it("does not show a download link when no file has been uploaded yet", () => {
    const container = renderEditView({ name: "Waiver", description: "", fileSrc: null })

    expect(downloadLink(container)).toBeNull()
  })
})
